// Human-friendly, accessible formatting. We show plain words and clear units
// rather than raw numbers or jargon wherever possible.

export const metresToFeet = (m) => (m == null ? null : Math.round(m * 3.28084));
export const msToKnots = (v) => (v == null ? null : Math.round(v * 1.94384));
export const msToMph = (v) => (v == null ? null : Math.round(v * 2.23694));

export function altitudeText(baroM, onGround) {
  if (onGround) return "On the ground";
  const ft = metresToFeet(baroM);
  if (ft == null) return "Altitude unknown";
  return `${ft.toLocaleString()} ft`;
}

export function speedText(ms) {
  const kt = msToKnots(ms);
  const mph = msToMph(ms);
  if (kt == null) return "Speed unknown";
  return `${kt} kn (${mph} mph)`;
}

const msToFpm = (ms) => ms * 196.85; // m/s -> feet per minute

export function verticalText(ms) {
  if (ms == null) return null;
  const fpmPerMin = Math.round(msToFpm(ms));
  if (Math.abs(fpmPerMin) < 60) return "Flying level";
  return fpmPerMin > 0
    ? `Climbing (${fpmPerMin.toLocaleString()} ft/min)`
    : `Descending (${Math.abs(fpmPerMin).toLocaleString()} ft/min)`;
}

export function headingText(deg) {
  if (deg == null) return "Heading unknown";
  const dirs = [
    "North", "North-east", "East", "South-east",
    "South", "South-west", "West", "North-west",
  ];
  const i = Math.round(deg / 45) % 8;
  return `${dirs[i]} (${Math.round(deg)}°)`;
}

export function agoText(lastContactSec) {
  if (!lastContactSec) return null;
  const secs = Math.max(0, Math.floor(Date.now() / 1000) - lastContactSec);
  if (secs < 60) return `${secs} sec ago`;
  const mins = Math.floor(secs / 60);
  return `${mins} min ago`;
}

export function prettyCallsign(cs) {
  return cs && cs.trim() ? cs.trim() : "No callsign";
}
